export const i18n = {
  defaultLocale: 'en',
  locales: ['en'],
  localeCookie: 'locale',
  prefixDefault: false,
}

export type Locale = (typeof i18n)['locales'][number]
export type Languages = {
  name: string
  code: Locale
  icon: string
}

export const languages: Languages[] = [
  {
    name: 'English',
    code: 'en',
    icon: '/assets/flags/gb.svg',
  },
  {
    name: 'Español',
    code: 'es',
    icon: '/assets/flags/es.svg',
  },
  {
    name: 'Deutsch',
    code: 'de',
    icon: '/assets/flags/de.svg',
  },
  {
    name: 'Polish',
    code: 'pl',
    icon: '/assets/flags/pl.svg',
  },
  {
    name: 'Português',
    code: 'pt',
    icon: '/assets/flags/pt.svg',
  },
  {
    name: 'Pусский',
    code: 'ru',
    icon: '/assets/flags/ru.svg',
  },
  {
    name: '中国',
    code: 'zh',
    icon: '/assets/flags/cn.svg',
  },
  {
    name: 'Français',
    code: 'fr',
    icon: '/assets/flags/fr.svg',
  },
  {
    name: 'Indonesia',
    code: 'id',
    icon: '/assets/flags/id.svg',
  },
  {
    name: 'Hindi',
    code: 'in',
    icon: '/assets/flags/in.svg',
  },
  {
    name: 'Italiano',
    code: 'it',
    icon: '/assets/flags/it.svg',
  },
  {
    name: '日本語',
    code: 'jp',
    icon: '/assets/flags/jp.svg',
  },
]
